export const COMMON_REQ = 'cris/businessUnit/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/businessUnit/COMMON_REQ_FAIL';

export const LOAD_BUSINESS_UNITS_SUCCESS = 'cris/businessUnit/LOAD_BUSINESS_UNITS_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	businessUnits: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_BUSINESS_UNITS_SUCCESS:
			const businessUnits = action.payload.data.business_units.map((item) => ({
				id: item.id,
				region_id: item.region_id,
				name: item.name,
				code: item.code,
				remark: item.remark || '',
				regionName: item.region.name
			}));

			return {
				...state,
				isLoading: false,
				businessUnits: businessUnits
			};

		default:
			return state;
	}
}